import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { FuUnit, FuUnitPayload } from 'icreate/common/models/fu-unit';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class FuUnitService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    async getList(fcuId: string) {
        return await lastValueFrom(
            this.http.get<FuUnit[]>(`${this.domain}/api/fuUnit`, {
                headers: this.headers,
                params: { fcuId },
            })
        );
    }

    async create(fuUnitData: FuUnitPayload[], fcuNum: number) {
        return await lastValueFrom(
            this.http.post<FuUnit[]>(
                `${this.domain}/api/fuUnit`,
                { fuUnitData, fcuNum },
                {
                    headers: this.headers,
                }
            )
        );
    }

    async update(fuUnitData: FuUnitPayload[], fcuId: string, fcuNum: number) {
        return await lastValueFrom(
            this.http.put<FuUnit[]>(
                `${this.domain}/api/fuUnits`,
                { fuUnitData, fcuNum },
                {
                    headers: this.headers,
                    params: { fcuId },
                }
            )
        );
    }
}
